export function calculateUnitTimers({ sorties, fort_battles: fortBattles, unit_info: unitInfo }) {
    const {
        seconds_to_start_primetime: secondsToStartPrimetime,
        seconds_to_end_primetime: secondsToEndPrimetime,
        expires_in: sortiesExpiresIn,
    } = sorties

    const {
        seconds_to_next_match_maker: secondsToMatchMaker,
        expires_in: fortBattleExpiresIn,
    } = fortBattles

    let primetimeStart = null
    if (secondsToStartPrimetime) {
        primetimeStart = Date.now() + secondsToStartPrimetime * 1000
    }

    let primetimeEnd = null
    if (secondsToEndPrimetime) {
        primetimeEnd = Date.now() + secondsToEndPrimetime * 1000
    }

    let nextMatchMakerTickAt = null
    if (secondsToMatchMaker) {
        nextMatchMakerTickAt = Date.now() + secondsToMatchMaker * 1000
    }

    const expiresIn = Math.min(...[
        sortiesExpiresIn,
        fortBattleExpiresIn,
    ].filter(item => item !== null))

    const expiresAt = (expiresIn !== Infinity ? (Date.now() + expiresIn * 1000) : null)

    const data = {
        sorties: {
            ...sorties,
            primetimeStart,
            primetimeEnd,
        },
        fort_battles: {
            ...fortBattles,
            nextMatchMakerTickAt,
        },
        expiresAt,
    }

    if (unitInfo) {
        data.unit_info = unitInfo
    }

    return data
}



// WEBPACK FOOTER //
// ./state/actions/helpers/unit_info.js